import React from 'react';
import { Box, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MenuItem } from '../../types/menuItems';

interface MenuItemProps extends MenuItem { active: boolean; onNavigate?: () => void; }

const MenuItemComponent: React.FC<MenuItemProps> = ({ name, icon: Icon, path, active, onNavigate }) => {
    const navigate = useNavigate();

    return (
        <ListItemButton selected={active} onClick={() => { navigate(path); onNavigate?.(); }}
            sx={{ mx: 1.5, mb: .65, px: 1.25, minHeight: 50, borderRadius: 2.25, color: 'rgba(255,255,255,.72)',
                position: 'relative', overflow: 'hidden', transition: 'background-color 180ms ease, color 180ms ease, transform 180ms ease',
                '&::before': { content: '""', position: 'absolute', left: 0, top: 9, bottom: 9, width: 3,
                    borderRadius: '0 4px 4px 0', bgcolor: active ? '#e2774f' : 'transparent', transition: 'background-color 180ms ease' },
                '&:hover': { bgcolor: 'rgba(226,119,79,.14)', color: '#fff', transform: 'translateX(2px)',
                    '& .nav-icon': { bgcolor: 'rgba(226,119,79,.22)', color: '#f09a77' } },
                '&.Mui-selected': { bgcolor: 'rgba(226,119,79,.18)', color: '#fff',
                    '&:hover': { bgcolor: 'rgba(226,119,79,.24)' },
                    '& .nav-icon': { bgcolor: '#d45f3c', color: '#fff', boxShadow: '0 8px 18px rgba(10,22,38,.24)' } } }}>
            <ListItemIcon sx={{ minWidth: 46 }}>
                <Box className="nav-icon" sx={{ width: 34, height: 34, borderRadius: 1.75, display: 'grid', placeItems: 'center',
                    bgcolor: 'rgba(255,255,255,.07)', color: 'rgba(255,255,255,.66)', transition: 'all 180ms ease',
                    '& svg': { fontSize: 19 } }}><Icon /></Box>
            </ListItemIcon>
            <ListItemText primary={name} primaryTypographyProps={{ sx: { fontWeight: active ? 700 : 560,
                fontSize: 14, letterSpacing: '-.01em', lineHeight: 1.25 } }} />
        </ListItemButton>
    );
};

export default MenuItemComponent;
